<template>
  <Layout>
  <div class="section content is-size-7">
    <p>
        E-Mail: <a href="mailto:ie.mg.cuca@778mobile.com">ie.mg.cuca@778mobile.com</a> <br>
        Helpline: <a href="tel:+35315566568">15566568</a>
    </p>
  </div>
  </Layout>
</template>

<script>
import Layout from '@/layouts/Kyf'

export default {
  name: 'Help',
  components: {
    Layout
  }
}
</script>




// WEBPACK FOOTER //
// src/components/LangKyf/IE/Help.vue